class StatePopup extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.js-search-input');
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.template = this.getAttribute('data-template');
    this.confirmButton = this.querySelector('#confirm-selection');
    this.closeButton = this.querySelector('#close-state-popup');
    this.backButton = this.querySelector('#back-btn');
    this.warningButton = this.querySelector('#show-warning-btn');
    this.errorMessage = this.querySelector('#error-message');
    this.deliveryLocation = this.querySelector('#delivery-location');
    this.pickupLocation = this.querySelector('#pickup-location');
    this.deliveryMethod = this.querySelector('#delivery__options');
    this.valid_zip = false;
    this.alreadyClicked = false;
    
    // Attach event listeners
    this.addListeners();
    this.fetchStateData();
    const preferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
    setTimeout(() => this.checkLocalStorage(), preferred == null ? Number(this.dataset.delay) * 1000 : 0);
  }

  addListeners(){
    this.confirmButton.addEventListener('click', this.handleConfirm.bind(this));
    this.closeButton.addEventListener('click', this.handleClose.bind(this));
    this.backButton.addEventListener('click', this.handleBack.bind(this));
    this.warningButton.addEventListener('click', this.handleWarning.bind(this));
    this.input.addEventListener('input', debounce(this.handleInput.bind(this), 450));
    this.deliveyOptions = this.querySelectorAll('.delivery__option');
    this.deliveyOptions.forEach((option) => {
      option.addEventListener('click', this.handleDeliveryOptionClick.bind(this, option));
    });
  }


  checkLocalStorage() {
    const preferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
    if (preferred) {
      this.deliveyOptions.forEach(option => {
        const input = option.querySelector('input');
        input.checked = false;
        if(preferred.method === input.value){
          input.checked = true;
          this.deliveryMethod.setAttribute('data-selected-value', input.value);
        }
      });
      // set active list for location and method
      const methods = ['Local Delivery', 'In-Store Pickup']
      if(!methods.includes(preferred.method)){
        return;
      }
      if(preferred.method === 'Local Delivery'){
        this.valid_zip = true;
        this.querySelector('#zipcode').value = preferred?.zip;
        const locations = this.getLocations(preferred?.zip);
        this.deliveryLocation.populateOptions(locations);
        this.setActiveList(this.deliveryLocation,preferred.location, preferred.id);
        this.deliveryLocation.querySelector('button').disabled = true;
        this.deliveryClasses();
      } else {
        const locations = this.getLocations();
        this.pickupLocation.populateOptions(locations);
        this.setActiveList(this.pickupLocation,preferred.location, preferred.id);
        this.pickupClasses();
      }
      this.filterProductsByTag(preferred.id);
    } else {
      if(!this.alreadyClicked) {
        for(const option of Array.from(this.deliveyOptions)){
          const input = option.querySelector('input');
          input.checked = true;
          this.deliveryMethod.setAttribute('data-selected-value', input.value);
          break;
        };
      }
      this.classList.remove('hide');
    }
  }

  pickupClasses(){
    this.querySelector('.zip__container').classList.add('hidden');
    this.querySelector('.pickup-results').classList.remove('hidden');
    this.querySelector('.local__delivery-results').classList.add('hidden');
  }

  deliveryClasses(){
    this.querySelector('.zip__container').classList.remove('hidden');
    this.querySelector('.local__delivery-results').classList.remove('hidden');
    this.querySelector('.pickup-results').classList.add('hidden');
  }

  handleWarning(evt){
    const zip = this.querySelector('#zipcode')?.value;
    const selectedMethod = this.deliveryMethod?.getAttribute('data-selected-value')?.trim();
    // console.log('this.valid', this.valid_zip);
    if(!zip && selectedMethod==='Local Delivery'){
      // console.log('in not having zip code block')
      this.setErrorMessage("Please enter a valid zip code.");
      return;
    } else if(selectedMethod==='Local Delivery' && !this.valid_zip){
      // console.log('in not valid zip code block')
      return;
    }
    const cartItems = document.querySelector('cart-items[data-empty="false"]');
    // console.log(cartItems);
    if (!cartItems) {
      this.handleConfirm(evt);
    } else {
      const popupInfo = this.querySelector('.popup__info');
      const confirmInfo = this.querySelector('.confirm__info');
      popupInfo.classList.add('hidden');
      confirmInfo.classList.remove('hidden');
    }
  }

  handleBack(){
    const popupInfo = this.querySelector('.popup__info');
    const confirmInfo = this.querySelector('.confirm__info');
    popupInfo.classList.remove('hidden');
    confirmInfo.classList.add('hidden');
  }

  handleInput() {
    if (this.input.value.length === 5) {
      const minZipCodeTX = 73301;
      const maxZipCodeTX = 88595;
      const value = parseInt(this.input.value, 10);
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
      if(value < minZipCodeTX || value > maxZipCodeTX){
        this.valid_zip = false;
        this.querySelector('.local__delivery-results').classList.add('hidden');
        this.setErrorMessage("Local delivery is not available in this zip code. Please select in-store pickup to proceed with your order.");
      } else {
        // console.log('within of range', value);
        const zipCodes = sessionStorage.getItem('zip_codes') || null;
        if(!zipCodes) return;
        // console.log('zip codes', zipCodes);
        const hasZipCode = zipCodes.includes(this.input.value);
        if(!hasZipCode) {
          this.valid_zip = false;
          this.querySelector('.local__delivery-results').classList.add('hidden');
          this.setErrorMessage("Local delivery is not available in this zip code. Please select in-store pickup to proceed with your order.");
        } else {
          this.setErrorMessage();
          const locations = this.getLocations(this.input.value);
          this.deliveryLocation.populateOptions(locations);
          this.valid_zip = true;
          this.deliveryLocation.querySelector('button').disabled = true;
          this.querySelector('.local__delivery-results').classList.remove('hidden');
        }
      }
    } else {
      this.valid_zip = false;
      this.setErrorMessage("Please enter a valid zip code");
      this.querySelector('.local__delivery-results').classList.add('hidden');
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
    }
  }

  getLocations (zip = null) {
    const data = JSON.parse(sessionStorage.getItem('locations')) || null;
    if (!data || !data?.processedLocations) {
      return [];
    }
    // console.log('get locations zip', zip);
    if(zip){
      return data.processedLocations.filter(loc => loc?.zipCodes?.includes(zip));
    } else {
      return data.processedLocations;
    }
  }

  setErrorMessage(errorMessage, hidden = false) {
    if(!errorMessage){
      hidden = true;
      errorMessage = '';
    }
    this.errorMessage.hidden = hidden ? true : false;
    this.errorMessage.textContent = errorMessage;
    this.errorMessage.setAttribute("aria-hidden", hidden ? "true" : "false");
  }

  removeActiveButton(element, text = null){
    element.removeAttribute('data-value');
    element.removeAttribute('data-id');
    element.firstElementChild.textContent = text != null ? text : '';
  }

  handleDeliveryOptionClick(option){
    this.deliveyOptions.forEach(option => option.querySelector('input').checked = false);
    const input = option.querySelector('input');
    input.checked = true;
    this.deliveryMethod.setAttribute('data-selected-value', input.value);
    if(input.name ==='pickup'){
      this.valid_zip = false;
      this.pickupClasses();
      this.removeActiveButton(this.pickupLocation.querySelector('button'), "Select Store");
    } else {
      this.input.value = '';
      this.deliveryClasses();
      this.removeActiveButton(this.deliveryLocation.querySelector('button'));
      this.deliveryLocation.querySelector('.custom-select__listbox').innerHTML = '';
      this.querySelector('.local__delivery-results').classList.add('hidden');
    }
    this.setErrorMessage();
    this.alreadyClicked = true;
  }

  fetchStateData() {
    const cachedData = sessionStorage.getItem('zip_codes') || null;
    if(!cachedData) {
      return fetch('/apps/stock_info/location', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            'Network response was not ok ' + response.statusText
          );
        }
        return response.json();
      })
      .then((data) => {
        // this.setStorage('locations', JSON.stringify(data), 3600);
        const locationsLen = data?.processedLocations?.length;
        let zipcodes = data?.processedLocations?.reduce((acc, curr, i)=> {
          acc+=curr.zipCodes != null ? (curr.zipCodes + (i < locationsLen - 1 ? ', ': '')): '' ;
          return acc;
        }, '');
        sessionStorage.setItem('zip_codes', JSON.stringify(zipcodes));
        sessionStorage.setItem('locations', JSON.stringify(data));
        this.pickupLocation.populateOptions(data.processedLocations);
      })
      .catch((error) => console.error('Error:', error));
    }
  }

  setActiveList(element, value, dataId = null){
    const button = element.querySelector('button');
    const list = element.querySelector('ul');
    const options = element.querySelectorAll('li');
    button.setAttribute('data-value', value);
    button.firstElementChild.textContent = value;
    if(dataId) button.setAttribute('data-id', dataId);
    options.forEach(option => {
      if(option.firstElementChild.textContent === value){
        option.setAttribute('aria-selected', 'true');
        option.classList.add('is-focused');
        list.setAttribute('aria-activedescendant', option.id);
      } else {
        option.setAttribute('aria-selected', 'false');
        option.classList.remove('is-focused');
      }
    });
  }

  handleConfirm(evt) {
    const selectedMethod = this.deliveryMethod?.getAttribute('data-selected-value')?.trim();
    let zip = null;
    let selectedLocation = null;
    let id = null;
    if(selectedMethod ==='Local Delivery'){
      selectedLocation = this.deliveryLocation.querySelector('.custom-select__btn')?.getAttribute('data-value')?.trim();
      id = this.deliveryLocation.querySelector('.custom-select__btn').getAttribute('data-id')?.trim();
      zip = this.querySelector('#zipcode')?.value;
    } else {
      selectedLocation = this.pickupLocation.querySelector('.custom-select__btn')?.getAttribute('data-value')?.trim();
      id = this.pickupLocation.querySelector('.custom-select__btn')?.getAttribute('data-id')?.trim();
    }
    const stockInline = document.querySelector('stock-inline');
    const prevPreferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
    if (selectedLocation && selectedMethod) {
      // Update preferred location and method in local storage
      if(prevPreferred && prevPreferred.id === id && prevPreferred.method === selectedMethod) {
        this.classList.add('hide');
        this.handleBack();
        return;
      }
      const preferred = { id: id, location: selectedLocation, method: selectedMethod };
      if(zip) preferred.zip = zip;
      localStorage.setItem('preferredLocation', JSON.stringify(preferred));

      this.filterProductsByTag(id);

      if(this.template === 'product'){
        const stock = window?.stock;
        const policy = document.querySelector('.product-info')?.getAttribute('data-inventory-policy');
        if(stockInline) {
          this.updateCountDisplay(id);
        }
        if(stock && policy!== 'continue')this.toggleButtonDisable();
      }

      // Hide popup and error message
      this.classList.add('hide');
      this.setErrorMessage();

      this.handleEmptyCart(id, selectedLocation, selectedMethod, zip, evt);
      this.updateHeaderDisplay(selectedLocation, selectedMethod);
      this.updateHeaderDisplay(selectedLocation, selectedMethod, true);
      this.handleBack();
    } else {
      this.setErrorMessage('Please select In-Store pickup or Local Delivery to proceed with your order.');
    }
  }

  handleClose(evt) {
    const preferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
    if(preferred){
      this.classList.add('hide');
      this.setErrorMessage();
      this.handleBack();
    } else {
      this.setErrorMessage('Please select In-Store pickup or Local Delivery to proceed with your order.');
    }
  }
  
  filterProductsByTag(location) {
    const products = document.querySelectorAll('.product-card');
    if(products && products.length > 0) {
      products.forEach((product) => {
        const policy = product.getAttribute('data-inventory-policy') === 'continue';
        if(!policy){
          const locationTags = product?.getAttribute('data-locations')?.split(',');
          const unavailableLabel = product.querySelector('.product-label-location-out');
          const button = product.querySelector('button');
          if (!locationTags?.includes(location)) {
            product.classList.add('location-sold-out');
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            if(unavailableLabel) unavailableLabel.classList.remove('hidden');
          } else {
            product.classList.remove('location-sold-out');
            button.disabled = false;
            button.setAttribute('aria-disabled', 'false');
            if(unavailableLabel) unavailableLabel.classList.add('hidden');
          }
        }
      });
    }
  }
  // update header for location
  updateHeaderDisplay(selectedState = 'Not Selected', selectedDM = 'Not Selected', mobile=false) {
    const currentLElem= document.getElementById(`${mobile ? 'mbl-':''}current-state`);
    const currentDMElem = document.getElementById(`${mobile ? 'mbl-':''}current-delivery-method`);
    currentLElem.textContent = `${selectedState}`;
    currentDMElem.textContent = `Method: ${selectedDM}`;
  }

  // update stock availability for location changed
  updateCountDisplay() {
    const preferred = JSON.parse(localStorage.getItem('preferredLocation')) || null;
    const counts = document.querySelectorAll('.stock__count--inline');
    const p = document.querySelector(".stock__availability");
    const unavailable = document.querySelector(`.stock__count--inline.location\\:${preferred.id}`);
    counts.forEach((count, i) => {
      if(count.classList.contains(`location:${preferred.id}`)) {
        count.classList.remove('hidden');
      } else {
        count.classList.add('hidden');
      }
    })
    if(!unavailable){
      p.insertAdjacentHTML('beforeend', `<span class="stock__count--inline location:${preferred.id} stock__out">Unavailable</span>`)
    }
  }

  toggleButtonDisable(){
    document.querySelector('.product-info .qty-input__input').value = 1;
    document.querySelector('.product-info .qty-input__btn[name="plus"]').disabled = false;

    const stockOutImg = document.querySelector('.stock__label .out-stock');
    const stockImg = document.querySelector('.stock__label .in-stock');
    const hasStockLabelImgs = stockOutImg && stockImg;
    const preferred = JSON.parse(localStorage.getItem("preferredLocation")) || null;
    // console.log(window.stock);
    const stockFound = window?.stock?.find(item => {
      const id = item.locationId.split('/').pop();
      return id === preferred.id;
    });
    if(stockFound) {
      const stockCount = stockFound.stock;
      // console.log(stockCount);
      if(stockCount >= 1){
        this.diableButton(false, 'ADD TO CART');
        if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, true);
      } else {
        this.diableButton(true, 'SOLD OUT');
        if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, false);
      }
    } else {
      this.diableButton(true, 'SOLD OUT');
      if (hasStockLabelImgs) this.showLabel(stockImg, stockOutImg, false);
    }
  }

  showLabel(stockImg, stockOutImg, stock = false){
    const stockLabel = document.querySelector('.stock__label');
    if (!stockLabel) return;
    stockLabel.lastElementChild.textContent = stock ? "In stock": "Out of stock";
    if(stock){
      stockImg?.classList.remove('hidden');
      stockOutImg?.classList.add('hidden');
      stockLabel.classList.add('in-stock');
    } else {
      stockImg?.classList.add('hidden');
      stockOutImg?.classList.remove('hidden');
      stockLabel.classList.remove('in-stock');
    }
  }

  diableButton(disabled = true, text = null) {
    const dynamicBtn = document.querySelector(
      '.product-info__dynamic-checkout-btn shopify-accelerated-checkout'
    );
    const buyBtns = document.querySelectorAll('.product-info__add-button button');
    buyBtns.forEach(btn => {
      btn.disabled = disabled ? true : false;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      const promoBtn = btn.getAttribute('data-type') === 'promo';
      const btnText = btn.textContent;
      if(text) btn.textContent = promoBtn ? btnText : text;
    })
    if (dynamicBtn) dynamicBtn.disabled = disabled ? true : false;
  }

  // empty cart on location change and update cart attributes 
  handleEmptyCart(id, location, method, zip = null, evt) {
    evt.preventDefault();
    try {
      fetch(`${theme.routes.cartClear}.js`, {
        method: 'POST'
      }).then((response) => {
        if (!response.ok) throw new Error(response.status);
        // Broadcast individual events to update product cards
        const cartItems = document.querySelector('cart-items[data-empty="false"]');
        if(cartItems){
          cartItems.querySelectorAll('.cart-item').forEach((cartItem) => {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                variantId: cartItem.dataset.variantId,
                newQuantity: 0
              }
            }));
          });
          this.refreshCartDrawer(cartItems);
        }

        // Proceed to update cart attributes
        fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              store_id: id,
              store: location,
              shipping_type: method,
              zip: zip ? zip : 'nil'
            }
          }),
        });
      });
    } catch (error) {
      console.error('cart update Error at location selection:', error);
      window.location.href = evt.target.href;
    }
  }

  // refresh cart drawer if it has items
  refreshCartDrawer(items) {
    try {
      items.refreshCartItems();
    } catch (error) {
      this.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: error ? error.message : null
        }
      }));
    }
  }
}

if (!customElements.get('state-popup')) {
  customElements.define('state-popup', StatePopup);
}